import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import '../PageCss/HansaFlexIndiaPages/Journey.css';
import JourneyCard from '../../Components/JourneyCard/JourneyCard';
import img2004 from '../../assets/Journey/2004.png';
import img2005 from '../../assets/Journey/2005.png';
import img2005ribbon from '../../assets/Journey/2005_ribbon.png';
import img2007 from '../../assets/Journey/2007.png';
import img2019 from '../../assets/Journey/2019.png';
import img2023 from '../../assets/Journey/2023_2.jpg';
import imgStage from '../../assets/journey-stage.jpg';
import img1999 from '../../assets/Journey/Brazil1999.jpg';
import imgbrazilianflag from '../../assets/Journey/brazilianflag.jpg';
import imgbrazilnew from '../../assets/Journey/Brazilnew.png';
import imgbrazilbranch from '../../assets/Journey/Brazilbranch.jpg'

import JourneyCardR from '../../Components/JourneyCard/JourneyCardR';
import CenterStage from '../../Components/CenterStage/CenterStage';
import imgHistoryStage from '../../assets/company-history.png';
import imgBrazilAgriculture from '../../assets/Journey/BrazilAgriculture.jpg';
import imgBrazilLandscape from '../../assets/Journey/Brazillandcape.jpg'
import AOS from 'aos';
import 'aos/dist/aos.css';

function Journey() {

    const isMobile = window.innerWidth <= 789;

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
        AOS.init({
            // Global settings:
            disable: false,
            startEvent: 'DOMContentLoaded',
            initClassName: 'aos-init',
            animatedClassName: 'aos-animate',
            useClassNames: false,

            // Settings that can be overridden on per-element basis:
            offset: 300,
            delay: 0,
            duration: 500,
            easing: 'ease',
            once: false,
            mirror: false,
            anchorPlacement: 'top-bottom',
        });
    }, []);



    return (
        <div className='journey-content'>
            <CenterStage imageSrc={imgBrazilLandscape} title="Come with us on our Journey !" paragraph="HANSA-FLEX Brazil boasts a storied history defined by strategic evolution and adaptability. Over time, it has showcased resilience and innovation, adeptly surmounting obstacles while steadily broadening its impact within the industry." />

            <div className='div-timeline-wrapper'>
                <br /><br /><br /><br />
                {isMobile ? <></> : <><div className='vertical-line'></div></>}

                <div>
                    <JourneyCard
                        title="1999"
                        description="Formation of HANSA-FLEX Hydraulics in Brazil"
                        imageUrl={img1999}
                        additionalDescription="Blumenau, Santa Catarina"
                    />
                </div>

                <div >
                    <JourneyCardR
                        title="Early 2000s"
                        description="Blumenau branch became a strategic hub"
                        imageUrl={imgBrazilAgriculture}
                        additionalDescription="Brazil’s agricultural, industrial, and construction sectors."
                    />
                </div>

                <div >
                    <JourneyCard
                        title="2001"
                        description="HANSA-FLEX expanded to other major Brazilian cities"
                        imageUrl={imgbrazilbranch}
                        additionalDescription="São Paulo, Rio de Janeiro, and Porto Alegre."
                    />
                </div>

                <div>
                    <JourneyCardR
                        title="Today"
                        description="HANSA-FLEX Brazil continues to support industries with 360° hydraulic solutions"
                        imageUrl={imgbrazilnew}
                        additionalDescription="HANSA-FLEX Brazil: A Legacy of Resilience, Innovation, and Strategic Growth"
                    />
                </div>

                {/* <div>
                    <JourneyCard
                        title="2019"
                        description="National Heavy Equipment Show"
                        imageUrl={img2019}
                        additionalDescription="Equipment Show"
                    />
                </div> */}

                {/* <div>
                    <JourneyCardR
                        title="2023"
                        description="Always assisting with hydraulic solutions, resilience, and innovation!"
                        imageUrl={img2023}
                        additionalDescription="Future of reliable hydraulics"
                    />
                </div> */}
            </div>
        </div>
    );
}

export default Journey;
